var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditorContainer',[_c('ModuleHeader',{attrs:{"title":_vm.$t('station.title'),"is-active":_vm.buffer != null}},[_c('ActivateToggleEditor',{attrs:{"id":_vm.id,"module-name":"station"}})],1),_c('v-expansion-panel-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }